import React from "react";
import { Card } from "@dreambigger/design-system/src/components";

type HeaderTextCard = {
  header: string;
  text: string;
};

// A generic card that display a title header and body of text.
const HeaderTextCard = ({ header, text }: HeaderTextCard) => {
  return (
    <Card
      style={{
        boxShadow: "rgba(0, 0, 0, 0.16) 0px 2px 2px",
      }}
    >
      <h4 className="mb-0 fwb">{header}</h4>
      <p className="mb-0" style={{ minHeight: "60px" }}>
        {text}
      </p>
    </Card>
  );
};

export default HeaderTextCard;
